import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

type GetOpenDockWarehouseFormFieldsFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  stopIndex: number
  params: {
    loadTypeId: string
  }
  config: Partial<HttpClientConfig>
}

export function getOpenDockWarehouseFormFieldsFactory({
  repository,
}: GetOpenDockWarehouseFormFieldsFactoryDependencies) {
  return async function getOpenDockWarehouseFormFields({
    shipmentUUID,
    stopIndex,
    params,
    config,
  }: Params) {
    try {
      return await repository.getOpenDockWarehouseFormFields(
        shipmentUUID,
        stopIndex,
        params,
        config
      )
    } catch (error) {
      throw new Error('Could not get OpenDock warehouse details', { cause: error as Error })
    }
  }
}

export function getOpenDockWarehouseFormFields({
  shipmentUUID,
  stopIndex,
  params,
  config,
}: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newGetOpenDockWarehouseFormFields = getOpenDockWarehouseFormFieldsFactory({
    repository,
  })
  return newGetOpenDockWarehouseFormFields({ shipmentUUID, stopIndex, params, config })
}
